var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.end}},[(_vm.isLoading)?[_vm._v(" 加载中 "+_vm._s(_vm.countdown)+"S ")]:[_vm._v(" 继续上课 ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }